import { __module as c } from "../../../_virtual/isIP.js";
import { a as t } from "./util/assertString.js";
Object.defineProperty(o = c.exports, "__esModule", {
  value: !0
}), o.default = function c(t) {
  var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
  return ((0, a.default)(t), o = String(o)) ? "4" === o ? !!r.test(t) && t.split(".").sort(function (c, t) {
    return c - t;
  })[3] <= 255 : "6" === o && !!u.test(t) : c(t, 4) || c(t, 6);
}, a = t && t.__esModule ? t : {
  default: t
}, n = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", e = "(".concat(n, "[.]){3}").concat(n), r = new RegExp("^".concat(e, "$")), s = "(?:[0-9a-fA-F]{1,4})", u = RegExp("^(" + "(?:".concat(s, ":){7}(?:").concat(s, "|:)|") + "(?:".concat(s, ":){6}(?:").concat(e, "|:").concat(s, "|:)|") + "(?:".concat(s, ":){5}(?::").concat(e, "|(:").concat(s, "){1,2}|:)|") + "(?:".concat(s, ":){4}(?:(:").concat(s, "){0,1}:").concat(e, "|(:").concat(s, "){1,3}|:)|") + "(?:".concat(s, ":){3}(?:(:").concat(s, "){0,2}:").concat(e, "|(:").concat(s, "){1,4}|:)|") + "(?:".concat(s, ":){2}(?:(:").concat(s, "){0,3}:").concat(e, "|(:").concat(s, "){1,5}|:)|") + "(?:".concat(s, ":){1}(?:(:").concat(s, "){0,4}:").concat(e, "|(:").concat(s, "){1,6}|:)|") + "(?::((?::".concat(s, "){0,5}:").concat(e, "|(?::").concat(s, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$"), c.exports = o.default, c.exports.default = o.default;
var o,
  a,
  n,
  e,
  r,
  s,
  u,
  i = c.exports;
export { i };